import {SceneEntity} from './types.ts';

const labels: Record<string, string> = {
    sphere: 'Sphere',
    box: 'Box',
    torus: 'Torus',
    cylinder: 'Cylinder',
    plane: 'Plane',
    disc: 'Disc',
    icosphere: 'Icosphere',
    model: 'Model',
    pointLight: 'Point Light',
    directionalLight: 'Directional Light',
    spotLight: 'Spot Light',
    hemisphericLight: 'Hemispheric Light',
    torusKnot: 'Torus Knot',
    ground: 'Ground',
    lines: 'Lines',
    dashedLines: 'Dashed Lines',
    tube: 'Tube',
    extrudeShape: 'Extrude Shape',
    lathe: 'Lathe',
    text: 'Text',
    group: 'Group',
    sceneSettings: 'Scene Settings'
};

// What the object list and the group picker call an entity: its name, if it
// has one, else what it is.
export default function sceneEntityLabel(entity: SceneEntity): string {
    if (entity.name) {
        return entity.name;
    }

    if (entity.type == 'model') {
        const fileName = entity.url.split('/').pop();
        return labels[entity.type] + ' - ' + fileName;
    }

    if (
        entity.type == 'text' &&
        typeof entity.text === 'string' &&
        entity.text.trim()
    ) {
        return labels[entity.type] + ' - ' + entity.text.trim().split('\n')[0];
    }

    return labels[entity.type] ?? entity.type;
}
